<template>
  <div>
    <CardTable
      style="height: 100%"
      ref="configTableRef"
      class="hc-biz-dc-brief__container dialog-body"
      :page="page"
      :initFuc="initFuc"
      :get-table-data="getTableData"
      :tableConfig="tableConfig"
    ></CardTable>
  </div>
</template>

<script>
import CardTable from '@/components/config-tables/card-table_new.vue'
import {
  // eslint-disable-next-line no-unused-vars
  ASYNC_EXPORT_CODE_ENUM,
  ASYNC_EXPORT_FILE_STATUS,
  HC_COL_PRESET_TYPE_VXE_GRID_ENUM,
} from '@/services/enums'
import debounce from 'lodash.debounce'
import { downloadFileFromOss } from '@/services/utils/modules/oss'
import apiDownload from '@/services/api/modules/download'

import FileStatus from './FileStatus.vue'

export default {
  anme: 'HcBizDownloadCenterBrief',
  components: {
    CardTable,
    FileStatus,
  },
  props: {
    exportCode: {
      type: String, // ASYNC_EXPORT_CODE_ENUM
      default: '',
    },
    page: {
      type: Object,
      default: () => {
        return {
          currentPage: 1,
          total: 0,
          pageSize: 20,
          pageSizes: [20, 50, 100, 200],
        }
      },
    },
  },
  data() {
    return {
      tableConfig: {
        hideActionBox: true,
        hidePagination: true,
        props: {
          columns: [
            {
              title: '文件名称',
              field: 'fileName',
              hcPreset: {
                type: HC_COL_PRESET_TYPE_VXE_GRID_ENUM.text.value,
              },
            },
            {
              title: '添加时间',
              field: 'created',
              hcPreset: {
                type: HC_COL_PRESET_TYPE_VXE_GRID_ENUM.text.value,
              },
            },
            {
              title: '生成时间',
              field: 'updated',
              hcPreset: {
                type: HC_COL_PRESET_TYPE_VXE_GRID_ENUM.text.value,
              },
            },
            {
              title: '文件状态',
              field: 'state',
              hcPreset: {
                type: HC_COL_PRESET_TYPE_VXE_GRID_ENUM.text.value,
              },
              slots: {
                default: ({ row }) => {
                  return [
                    <FileStatus
                      status={row.state}
                      percentage={row.progress}
                    ></FileStatus>,
                  ]
                },
              },
            },
            {
              title: '操作',
              field: 'operation',
              hcPreset: {
                type: HC_COL_PRESET_TYPE_VXE_GRID_ENUM.operation.value,
                operationOptions: ({ row }) => {
                  const isCanDownload =
                    row.state === ASYNC_EXPORT_FILE_STATUS.generated.value
                  const options = []

                  if (isCanDownload) {
                    options.push({
                      label: '下载',
                      value: 'download'
                    })
                  }

                  return options
                },
                operationHandler: ({ cmd, row }) => {
                  if (cmd === 'download') {
                    this.handleDownload(row)
                  }
                }
              },
              slots: {
                // default: ({ row }) => {
                //   const isCanDownload =
                //     row.state === ASYNC_EXPORT_FILE_STATUS.generated.value

                //   return [
                //     isCanDownload && (
                //       <ElButton
                //         type="text"
                //         size="mini"
                //         vOn:click={() => this.handleDownload(row)}
                //       >
                //         下载
                //       </ElButton>
                //     ),
                //   ]
                // },
              },
            },
          ],
          border: false,
        },
      },
    }
  },
  computed: {
    taskCompleteMsgCounter() {
      return this.$store.state.downloadCenter.msgCounter
    }
  },
  watch: {
    taskCompleteMsgCounter(val, oldVal) {
      if (val === oldVal) {
        return
      }
      console.log('===简版下载中心,收到消息,立即更新页面')
      this.flushTableDataConditional()
    }
  },
  methods: {
    async getTableDataWithPercentage(tableData) {
      try {
        if (!tableData || tableData.length === 0) {
          return tableData
        }

        const ids = tableData
          .filter(
            // 过滤生成中的
            (item) => item.state === ASYNC_EXPORT_FILE_STATUS.generating.value
          )
          .map((item) => item.exportId)

        if (ids.length === 0) {
          console.log('没有生成中的记录，取消定时获取百分比')
          return tableData
        }

        const { code, data = [] } =
          (await apiDownload.fetchPercentageAsyncExport(ids)) || {}
        if (code !== 200 || !data || data.length === 0) {
          return tableData
        }
        tableData.forEach((row) => {
          const findObj = data.find((item) => item.exportId === row.exportId)
          if (findObj) {
            // 猜测这里能响应式更新
            // 这种改动不会触发自动宽度的计算因为 tableData ref 没有动
            row.percentage = findObj.progress
          }
        })

        return tableData
      } catch (err) {
        console.log('获取进度失败')
        return tableData
      }
    },
    async flushTableDataConditional() {
      console.log('开始定时异步更新进度条')
      try {
        if (!this.$refs?.configTableRef) {
          return
        }

        const tableData = this.$refs.configTableRef.tableData || []
        if (!tableData || tableData.length === 0) {
          return
        }

        const needUpdateList = tableData.filter(
          // 过滤需要刷新的行
          (item) => {
            const arr = [
              ASYNC_EXPORT_FILE_STATUS.init.value,
              ASYNC_EXPORT_FILE_STATUS.generating.value,
            ]

            return arr.includes(item.state)
          }
        )
        if (needUpdateList.length === 0) {
          console.log('没有生成中的记录,不需要刷新页面')
          return
        }

        // 更新本页数据
        this.$refs.configTableRef.flushDataWithoutLoading()
      } catch (err) {
        console.log('获取进度失败')
      }
    },
    handleDownload: debounce(async function(row) {
      console.log('123123132321')
      if (!row.fileUrl) {
        this.$message.error('下载失败，该行没有fileUrl')
        return
      }

      downloadFileFromOss(row.fileUrl)
    }, 500),
    initFuc() {},
    async getTableData(page, size) {
      // 获取表格数据
      const params = {
        pageNum: 1,
        pageSize: 10,
        exportCode: this.exportCode || '',
        // todo 增加code
      }
      this.params = params

      try {
        const res = await apiDownload.fetchListAsyncExportPage(params)
        const { code, data = {} } = res || {}
        if (code !== 200) {
          return
        }

        // 加上进度条
        // const tableData = await this.getTableDataWithPercentage(
        //   data.list || []
        // )
        return {
          tableData: data.list || [],
          currentPage: data.pageNum,
          pageSize: data.pageSize,
          total: data.total,
        }
      } catch (err) {
        console.log(err)
        return {
          tableData: [],
          total: -1,
        }
      }
    },
  },
  created() {
    this.intervalId = setInterval(() => {
      this.flushTableDataConditional()
    }, 1000 * 60)
  },
  beforeDestroy() {
    clearInterval(this.intervalId)
  },
}
</script>
